<template>
  <div class="datepickerrange">
    <div class="dateselector dateselector-start">
      <dateselector
        :date="start"
        @changed="setStartDate">
      </dateselector>
    </div>
    <div class="dateselector dateselector-line">
      -
    </div>
    <div class="dateselector dateselector-end">
      <dateselector
        :date="end"
        @changed="setEndDate">
      </dateselector>
    </div>
  </div>
</template>

<script>
import dateselector from './DateSelector'
import moment from 'moment'
import eventbus from '../../eventbus' // eslint-disable-line no-unused-vars

export default {
  name: 'datepickerrange',
  components: {dateselector},
  props: {
    allowSameDate: {
      type: Boolean,
      default: false
    },
    startdate: {
      default () {
        return moment()
      }
    },
    enddate: {
      default () {
        return this.allowSameDate ? moment() : moment().add(1, 'days')
      }
    },
    maximumDateRange: {
      type: Number,
      default: null // Default is null, which means unlimited range
    }
  },
  data () {
    return {
      start: this.startdate,
      end: this.enddate
    }
  },
  watch: {
    enddate () {
      this.end = this.enddate
    },
    startdate () {
      this.start = this.startdate
    }
  },
  methods: {
    checkIfDatesAreMoreThanMaxRange (startDate, endDate) {
      // Check if maximumDateRange is null, undefined, or non-positive, meaning no limit on the range
      if (!this.maximumDateRange || this.maximumDateRange <= 0) {
        return false
      }

      // Calculate the difference in days between startDate and endDate
      const start = moment(startDate)
      const end = moment(endDate)
      const dateDifference = end.diff(start, 'days')

      // Return true if the difference exceeds the maximumDateRange
      return dateDifference > this.maximumDateRange
    },
    setStartDate (date) {
      if (this.startIsAfterEnd(date, this.end)) {
        this.setEndDate(this.addDaysToEnd(date))
      }
      if (this.checkIfDatesAreMoreThanMaxRange(date, this.end)) {
        const txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end')
        eventbus.toast = {text: txt, 'success': false}
        const newEndDate = moment(date).add(this.maximumDateRange, 'days')
        this.setEndDate(newEndDate)
      }
      this.start = date
      setTimeout(_ => {
        this.$emit('startchanged', this.start)
      }, 0)
    },
    setEndDate (date) {
      if (this.startIsAfterEnd(this.start, date)) {
        this.setStartDate(this.substractDaysToStart(date))
      }
      if (this.checkIfDatesAreMoreThanMaxRange(this.start, date)) {
        const txt = this.$t('vue2.datepicker.max_date_range_start') + ' ' + this.maximumDateRange + ' ' + this.$t('vue2.datepicker.max_date_range_end')
        eventbus.toast = {text: txt, 'success': false}
        const newStartDate = moment(date).subtract(this.maximumDateRange, 'days')
        this.setStartDate(newStartDate)
      }
      this.end = date
      setTimeout(_ => {
        this.$emit('endchanged', this.end)
      })
    },
    startIsAfterEnd (startDate, endDate) {
      let start = moment(startDate).format('YYYY-MM-DD')
      let end = moment(endDate).format('YYYY-MM-DD')
      if (this.allowSameDate) {
        return moment(start).isAfter(end)
      } else {
        return moment(start).isSameOrAfter(end)
      }
    },
    addDaysToEnd (date) {
      if (this.allowSameDate) {
        return moment(date)
      } else {
        return moment(date).add(1, 'days')
      }
    },
    substractDaysToStart (date) {
      if (this.allowSameDate) {
        return moment(date)
      } else {
        return moment(date).subtract(1, 'days')
      }
    }
  },
  mounted () {
    // Set dates to make sure that startIsAfterEnd
    this.setEndDate(moment(this.enddate))
    this.setStartDate(moment(this.startdate))
  }
}
</script>

<style scoped>
.dateselector-start {
  margin-bottom: 0.5rem
}

.dateselector.dateselector-line {
  display: none;
}

.datepickerrange {
  min-width: 350px;
}

@media handheld, only screen and (min-width: 767px) {
  .dateselector {
    display: inline-block;
  }

  .dateselector-start {
    margin-bottom: 0px;
  }

  .dateselector.dateselector-line {
    display: inline-block;
    padding: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// DatePickerRange.vue?aeb47524